import React, { useState } from 'react';
import { Menu } from 'lucide-react';
import BillValidationSidebar from './BillValidationSidebar';
import { Button } from '../../../foundation/altzero_base/base/components/ui/button';
import { useIsMobile } from '../../../foundation/altzero_base/base/components/ui/use-mobile';

type Props = { children: React.ReactNode };

export default function BillValidationLayout({ children }: Props) {
  const isMobile = useIsMobile();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="flex min-h-full bg-gray-50">
      <BillValidationSidebar
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />

      <div className="flex-1 min-w-0">
        {isMobile && (
          <div className="fixed top-4 left-4 z-40">
            <Button
              variant="outline"
              size="icon"
              onClick={() => setMobileOpen(true)}
              className="bg-white shadow-lg"
            >
              <Menu className="h-5 w-5" />
            </Button>
          </div>
        )}
        <main className="p-4 md:p-6">
          {children}
        </main>
      </div>
    </div>
  );
}
